<template>
  <mdb-container fluid>
    <mdb-btn @click="addPromoCode" color="indigo">{{
      $t("add_new_promo_code")
    }}</mdb-btn>
    <DataTableAG
      :columns="columns"
      width="800px"
      height="700px"
      archivecontentpath2=""
      :getcontentpath="getpromocodespath"
      :buttonList="['Muokkaa', 'Poista']"
      jsonobject="promocodes"
      v-on:pressed-button1="editPromoCode"
      v-on:pressed-button2="deletePromoCode"
      :rowHeight="90"
    />
    <EditPromoCode
      v-if="editPromoCodeModal"
      :id="id"
      :modal-show="editPromoCodeModal"
      :promocode="promocode"
      :product_google="product_google"
      :product_apple="product_apple"
      :duration="duration"
      :add-promo-code-state="addPromoCodeState"
      v-on:modal-cancelled="editPromoCodeCancelled"
      v-on:modal-ok="editPromoCodeOk"
    />
  </mdb-container>
</template>

<script>
import DataTableAG from "@/components/DataTableAG.vue";
import { mdbContainer } from "mdbvue";
import EditPromoCode from "../components/EditPromoCode.vue";
import {
  mdbBtn,
} from "mdbvue";

export default {
  name: "PromoCodes",
  components: {
    DataTableAG,
    mdbContainer,
    EditPromoCode,
    mdbBtn
  },
  methods: {
    loadingReady() {
      this.loadReady = true;
    },
    editPromoCodeCancelled() {
      this.editPromoCodeModal = false;
    },
    editPromoCodeOk() {
      this.editPromoCodeModal = false;
      this.componentKey += 1;
    },
    editPromoCode(rowData) {
      this.id = rowData.id;
      this.promocode = rowData.promocode;
      this.product_google = rowData.product_google;
      this.product_apple = rowData.product_apple;
      this.duration = rowData.duration;
      this.editPromoCodeModal = true;
    },
    addPromoCode() {
      this.id = 0;
      this.promocode = "";
      this.product_google = "";
      this.product_apple = "";
      this.duration = "";
      this.addPromoCodeState = true;
      this.editPromoCodeModal = true;
    },
    deletePromoCode(rowData) {
      this.postdata = JSON.stringify({
        sessionid: this.$store.getters.getToken,
        id: rowData.id,
      });
      this.$http
        .post(
          this.deletefrontpagespath, this.postdata
        )
        .then((response) => {
          if (response.status == 200) {
            this.$notify.success({
              message: this.$t("deleting_promocode_success"),
              position: "top right",
              timeOut: this.$store.state.notifytimeoutshort,
            });
          }
          setTimeout(() => {
            this.$router.go();
          }, 1000);
        })
        .catch((error) => {
          this.$notify.error({
            message: this.$t("deleting_promocode_not_success"),
            position: "top right",
            timeOut: this.$store.state.notifytimeoutmedium,
          });
          console.log(error);
        })
        .finally(() => (this.loading = false));
    },
  },
  data: () => ({
    getpromocodespath: "/1.0/front/promocodes",
    setactivefrontpagespath: "/1.0/front/unionmember/frontpage/activate",
    deletefrontpagespath: "/1.0/front/promocode/archive",
    addPromoCodeState: false,
    editPromoCodeModal: false,
    columns: [
      {
        field: "promocode",
        headerName: "Koodi",
        width: 150,
        pinned: "left",
        sortable: true,
        filter: true,
        resizable: true,
      },
      {
        field: "product_google",
        headerName: "Koodi",
        width: 150,
        pinned: "left",
        sortable: true,
        filter: true,
        resizable: true,
      },
      {
        field: "product_apple",
        headerName: "Koodi",
        width: 150,
        pinned: "left",
        sortable: true,
        filter: true,
        resizable: true,
      },
      {
        field: "duration",
        headerName: "Kesto",
        width: 150,
        pinned: "left",
        sortable: true,
        filter: true,
        resizable: true,
      },
    ],
  }),
  mounted() {},
};
</script>